import React, { ChangeEvent, FC, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Label from "../../../../components/Label";
import Select from "../../../../components/Select";
import SearchInput, { Value } from "../../../../components/SearchInput";
import {
  resetFilter,
  selectOfferingsState,
  updateFilter,
  updateTextFilter,
} from "../../../../store/offerings";
import {
  fetchProductLinesRequest,
  selectProductLines,
} from "../../../../store/metadata";
import { IProductLine } from "../../../../services/api/productLine/types";
import { PROVIDERS } from "../../../../utils/common/contants";

import "./styles.scss";

export const FilterSection: FC = () => {
  const { t } = useTranslation();
  const data = useSelector(selectOfferingsState);
  const productLines = useSelector(selectProductLines);
  const dispatch = useDispatch();

  const productLineOptions = useMemo(() => {
    return [
      "all",
      ...productLines.map((productLine: IProductLine) => {
        return productLine.code;
      }),
    ];
  }, [productLines]);

  useEffect(() => {
    if (!productLines.length) {
      dispatch(fetchProductLinesRequest());
    }
  }, [dispatch, productLines]);

  const handleResetFilter = () => {
    dispatch(resetFilter());
  };

  const handleSearchSubmit = (value: Value) => {
    dispatch(updateFilter({ filterText: value }));
  };

  const handleSearchChange = (value: Value) => {
    dispatch(updateTextFilter(value));
  };

  const handleSubscriotionProviderChange = (
    event: ChangeEvent<HTMLSelectElement>,
  ) => {
    dispatch(updateFilter({ spCode: event.target.value }));
  };

  const handleProductChange = (event: ChangeEvent<HTMLSelectElement>) => {
    dispatch(updateFilter({ productLineCode: event.target.value }));
  };

  const validateSearch = (value: string) => {
    return value.length >= 3;
  };

  return (
    <section className="ams-offerings-filters">
      <div className="ams-offerings-filter-group ams-offerings-search-group">
        <Label className="ams-offerings-filters__label">
          {t("searchOfferings")}
        </Label>
        <SearchInput
          value={data.filterText.value}
          onSearchChange={handleSearchChange}
          onSearchSubmit={handleSearchSubmit}
          validate={validateSearch}
        />
      </div>
      <div className="ams-offerings-filter-group ams-offerings-subscription-provider-group">
        <Label className="ams-offerings-filters__label">
          {t("subscriptionProvider")}
        </Label>
        <Select
          className="ams-offerings-filters__select"
          name="filterSubscriptionProvider"
          value={data.spCode}
          onChange={handleSubscriotionProviderChange}
        >
          <option value="all">{t("all")}</option>
          {PROVIDERS.map((provider: string) => {
            return (
              <option value={provider} key={provider}>
                {t(provider)}
              </option>
            );
          })}
        </Select>
      </div>
      <div className="ams-offerings-filter-group ams-offerings-product-line-group">
        <Label className="ams-offerings-filters__label">
          {t("productLine")}
        </Label>
        <Select
          className="ams-offerings-filters__select"
          name="filterProduct"
          value={data.productLineCode}
          onChange={handleProductChange}
        >
          {productLineOptions.map((product: string) => {
            return (
              <option value={product} key={product}>
                {t(product)}
              </option>
            );
          })}
        </Select>
      </div>
      <button
        className="ams-offerings-filter-button"
        onClick={handleResetFilter}
      >
        Reset
      </button>
    </section>
  );
};
